import { request } from "../client";

import type { GeneratedTextResponse } from "../types/text";
import type {
  MaterialCreationRequest,
  MaterialInvitation,
  ReceivedMaterialsResponse,
} from "@lingoshade/domain";

export type {
  ReceivedMaterial,
  ReceivedMaterialsResponse,
} from "@lingoshade/domain";

export type MaterialsEndpoints = {
  create: (
    input: MaterialCreationRequest,
    token?: string | null,
  ) => Promise<GeneratedTextResponse>;
  received: (
    filters: {
      language?: string;
      level?: string;
      hidden?: boolean;
      search?: string;
    },
    token?: string | null,
  ) => Promise<ReceivedMaterialsResponse>;
  invitations: (
    textId: string,
    token?: string | null,
  ) => Promise<{ invitations: MaterialInvitation[] }>;
  assign: (
    textId: string,
    relationshipId: string,
    token?: string | null,
  ) => Promise<MaterialInvitation>;
  revoke: (textId: string, id: string, token?: string | null) => Promise<void>;
  updateReceived: (
    id: string,
    action: "decline" | "hide" | "restore",
    token?: string | null,
  ) => Promise<void>;
};
export function createMaterialsEndpoints(baseUrl: string): MaterialsEndpoints {
  return {
    create: (body, token): Promise<GeneratedTextResponse> =>
      request(baseUrl, "/materials", { method: "POST", body, token }),
    received: (query, token): Promise<ReceivedMaterialsResponse> =>
      request(baseUrl, "/materials/received", { method: "GET", query, token }),
    invitations: (
      textId,
      token,
    ): Promise<{ invitations: MaterialInvitation[] }> =>
      request(baseUrl, `/materials/${textId}/invitations`, {
        method: "GET",
        token,
      }),
    assign: (textId, relationshipId, token): Promise<MaterialInvitation> =>
      request(baseUrl, `/materials/${textId}/invitations`, {
        method: "POST",
        body: { relationshipId },
        token,
      }),
    revoke: (textId, id, token): Promise<void> =>
      request(baseUrl, `/materials/${textId}/invitations/${id}`, {
        method: "DELETE",
        token,
      }),
    updateReceived: (id, action, token): Promise<void> =>
      request(baseUrl, `/materials/received/${id}`, {
        method: "PATCH",
        body: { action },
        token,
      }),
  };
}
